import { makeStyles, Tooltip, Typography } from '@material-ui/core';
import { AnnoNode, Annotation } from '../../domain/domain';
import React from 'react';
import classnames from 'classnames';
import { stripTags } from '../../utils';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../reducers';
import { findSubTreeByannoId } from './utils';

type Props = {
    nodeId: number
}

const useStyles = makeStyles(_ => ({
    nodeHasPendingApproval: {
        color: 'red'
    },
    unselectable: {
        WebkitUserSelect: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none',
        userSelect: 'none'
    },
    editField: {
        width: '100%'
    }
}));

const getHeading = (subTree: Annotation | AnnoNode) : string => {
    if ("type" in subTree) {
        return (subTree.type === 'ANNOTEXT' ? 'Content' : subTree.workingCopy) || '';
    }

    return "ANNOTATION";
}

const renderNodeText = (subTree: AnnoNode | Annotation, classes: any) => {
    if (subTree.subTreeHasUnapprovedChanges) {
        return <Typography variant='body1' className={classnames(classes.nodeHasPendingApproval, classes.unselectable)}>*{stripTags(getHeading(subTree))}</Typography>
    } else {
        return <Typography className={classes.unselectable} variant='body1'>{stripTags(getHeading(subTree))}</Typography>
    }
}

const renderNodeChangesAsTooltip = (subTree: AnnoNode | Annotation) => {
    let textParts = []

    if(subTree.subTreeHasUnapprovedChanges && !subTree.nodeHasChanges){
        textParts.push("Child(ren) has changes");
    }
    if ('type' in subTree) {
        if(subTree.subTreeHasUnapprovedChanges && subTree.nodeHasChanges && subTree.type !== 'ANNOTEXT'){
            textParts.push("Heading/Headnote has changes");
        }

        if(subTree.subTreeHasUnapprovedChanges && subTree.nodeHasChanges && subTree.type === 'ANNOTEXT'){
            textParts.push("Content has changes");
        }
    }

    if(textParts.length === 0){
        return "";
    }

    return (textParts.map((part) => {
        return <p>{part}</p>
    }));
}

const AnnoNodeTitle: React.FC<Props> = ({ nodeId }) => {

    const editorNode = useSelector((app: ApplicationState) => app.comp.editorNode);
    let annotations = editorNode?.annotations
    const classes = useStyles();

    if (annotations === undefined) {
        return false;
    }

    let subTree: Annotation | AnnoNode | undefined;

    if (nodeId === 0) {
        subTree = annotations;
    } else {
        subTree = findSubTreeByannoId(annotations, nodeId);
    }

    if (subTree === undefined) {
        return false;
    }

    return (<Tooltip title={renderNodeChangesAsTooltip(subTree)}>
        {renderNodeText(subTree, classes)}
    </Tooltip>)
}

export default AnnoNodeTitle;
